import { render } from "./QualityControl.vue?vue&type=template&id=e9bc23ca"
import script from "./QualityControl.vue?vue&type=script&lang=js"
export * from "./QualityControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__